import React from 'react';
import { Box, Typography, Container, Grid, Button } from '@mui/material';
import backgroundImage from '../../images/homeimge.jpg';
import spaImage from '../../images/tea1.jpg';
import islandImage from '../../images/food2.jpg';
import dineImage from '../../images/tea3.jpg';

function SecSix() {
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        py: 10,
        height: '400px',
        mb: {
          xs: 255, // Mobile
          sm: 220, // Tablet
          md: 60, // Laptop
          lg: 60, // Larger screens
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Semi-transparent dark overlay
          zIndex: 1,
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        {/* Header Section */}
        <Box sx={{ textAlign: 'center', color: '#fff', mb: 8 }}>
       
          <Typography
            variant="h3"
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 700,
              fontSize: '3rem',
              mb: 3,
              lineHeight: 1.3,
            }}
          >
            Unforgettable Experiences Await
          </Typography>
        
        </Box>

        {/* Content Section */}
        <Grid container spacing={4}>
          {/* Spa & Wellness */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                position: 'relative',
                border: '1px solid rgba(255, 255, 255)',
                overflow: 'hidden',
                mb: 4,
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  border: '1px solid #ffffff',
                },
              }}
            >
              <Box
                component="img"
                src={spaImage}
                alt="Spa & Wellness"
                sx={{
                  width: '100%',
                  height: '400px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.05)', // Adds a subtle zoom effect
                  },
                }}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: '600',
                textAlign: 'center',
                mb: 2,
                fontSize: '1.8rem',
              }}
            >
             Are you ready to get your hands a little green?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                color: '#6c757d',
                mb: 3,
                fontSize: '1rem',
              }}
            >
           
Immerse yourself in the serene art of tea plucking, guided by experts while connecting with nature in lush green landscapes.
            </Typography>
            <Box sx={{ textAlign: 'center' }}>
              {/* <Button
                variant="text"
                sx={{
                  color: '#000',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  fontSize: '1rem',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Discover More
              </Button> */}
            </Box>
          </Grid>

          {/* Island Activities */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                position: 'relative',
                border: '1px solid rgba(255, 255, 255)',
                overflow: 'hidden',
                mb: 4,
                mt: 7,
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  border: '1px solid #ffffff',
                },
              }}
            >
              <Box
                component="img"
                src={islandImage}
                alt="Island Activities"
                sx={{
                  width: '100%',
                  height: '400px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: '600',
                textAlign: 'center',
                mb: 2,
                fontSize: '1.8rem',
              }}
            >
             A Unique Culinary Experience
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                color: '#6c757d',
                mb: 3,
                fontSize: '1rem',
              }}
            >
              
             Learn the art of creating this delicious dish, steeped in rich cultural history, as our expert chefs guide you through every step.
            </Typography>
            <Box sx={{ textAlign: 'center' }}>
              {/* <Button
                variant="text"
                sx={{
                  color: '#000',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  fontSize: '1rem',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Discover More
              </Button> */}
            </Box>
          </Grid>

          {/* Gastronomic Dine */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                position: 'relative',
                border: '1px solid rgba(255, 255, 255)',
                overflow: 'hidden',
                mb: 4,
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  border: '1px solid #ffffff',
                },
              }}
            >
              <Box
                component="img"
                src={dineImage}
                alt="Gastronomic Dine"
                sx={{
                  width: '100%',
                  height: '400px',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.05)',
                  },
                }}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: '600',
                textAlign: 'center',
                mb: 2,
                fontSize: '1.8rem',
              }}
            >
               Tea Factory Visit
            </Typography>
            <Typography
              variant="body1"
              sx={{
                textAlign: 'center',
                color: '#6c757d',
                mb: 3,
                fontSize: '1rem',
              }}
            >
            Witness traditional methods of tea processing, including drying, crushing, and heating, showcasing the craftsmanship behind tea.
            </Typography>
            <Box sx={{ textAlign: 'center' }}>
              {/* <Button
                variant="text"
                sx={{
                  color: '#000',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  fontSize: '1rem',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Discover More
              </Button> */}
            </Box>
          </Grid>
        </Grid>
      </Container>
      <hr />
    </Box>
  );
}

export default SecSix;
